<template>
  <div class="admin-reports">
    <base-popup v-if="isShowReportPopup" @close="closeReport">
      <template #actions>
        <base-button class="admin-reports__download-button" outline @click="printReport">
          <icon-download class="admin-reports__download-icon" /> Download full report
        </base-button>
      </template>
      <admin-report :report="activeReport" />
    </base-popup>

    <div v-else class="admin-reports__content">
      <h1 class="admin-reports__title">Reports</h1>
      <base-table class="admin-reports__table" :columns="reportColumns" :data="reports" @row-click="openReport" />
    </div>
  </div>
</template>

<script>
import BaseButton from '@components/common/BaseButton.vue'
import IconDownload from '@components/svg/IconDownload.vue'
import BasePopup from '@components/common/BasePopup.vue'
import BaseTable from '@components/common/BaseTable.vue'
import AdminReport from '@components/admin/AdminReports/AdminReport.vue'
import store from "@store";

import toast from '@utils/toast'
import { mapGetters } from 'vuex'

export default {
  name: 'AdminReports',
  components: { AdminReport, BaseTable, BasePopup, BaseButton, IconDownload },
  data() {
    return {
      store,
      reports: [],
      activeReport: null,

      isShowReportPopup: false
    }
  },
  computed: {
    ...mapGetters({
      user: 'getUser',
      token: 'getToken',
      schema: 'getSchema',
    }),

    reportColumns() {
      return [
        { label: 'REPORT ID', value: 'report_id' },
        { label: 'TITLE', value: 'title' }
      ]
    }
  },
  mounted() {
    this.fetchReports()
  },
  methods: {
    fetchReports() {
      const data =  {
        API_KEY: this.store.getters.keys.api_key,
        code: this.token.token,
        user: this.user.user
      }
      this.request('/admin/list/reports/', 'POST', data)
        .then(response => {
          if (response.code === 0) {
            toast.successMessage('Data is received')
            this.reports = [ ...response.data ]
          } else {
            toast.errorMessage(response.message)
          }
        })
        .catch((error) => {
          toast.errorMessage(error)
        })
    },

    openReport(report) {
      this.activeReport = report
      this.isShowReportPopup = true
    },

    closeReport() {
      this.isShowReportPopup = false
    },

    printReport() {
      window.print()
    }
  }
}
</script>

<style scoped>
.admin-reports * {
  box-sizing: border-box;
}

.admin-reports {
  width: 100%;
  height: 100%;
  text-align: left;
  overflow-y: hidden;
  position: relative;
}

.admin-reports__title {
  margin: 0;
}

.admin-reports__content {
  padding: 80px 20px;
}

.admin-reports__table {
  width: 100%;
  margin-top: 60px;
}

.admin-reports__download-button {
  margin-right: 1rem;
}

.admin-reports__download-icon {
  height: 16px;
  width: 16px;
  margin-right: 0.5rem;
}
</style>
